<template lang="pug">
  .client-details(v-if="client")
    aside.client(:class="{ 'is-vip': client.vip }")
      .vip-badge(v-if="client.vip")
        img(src="@/assets/vip-badge.png")
      h2 {{ client.name }}
      span.user-level(v-if="!['User', 'Guest', 'Regular', 'Donator'].includes(client.level)", title="This player is part of an administrative group.") {{ client.level }}
      .client-info
        .info-item
          .icon #[clock-icon]
          .info
            .title Member Since
            .value {{ client.time_add | prettyDate }}
        .info-item
          .icon #[eye-outline-icon]
          .info
            .title Last Seen
            .value {{ client.time_edit | prettyDate }}
        .info-item
          .icon #[img(src="@/assets/icons/connections.svg", width=24)]
          .info
            .title Connections
            .value {{ client.connections | commaFormat }}
      .client-ranks
        .title Server Ranks
        .server(v-for="server in client.servers")
          .title {{ server.name }}
          .values
            .item.rank
              .title Rank
              .value {{ server.rank | commaFormat }}
            .item.xp
              .title XP
              .value {{ server.xp | commaFormat }}
    .main
      h2 Personal Bests

      h3.record-list-title(@click="recordListSurf = !recordListSurf", :class="{ active: recordListSurf }")
        span Surf
        span.server-ip raid-gaming.net:28965
        chevron-down-icon
      table.record-list(v-if="recordListSurf", cellspacing="0", cellpadding="0")
        tr(v-if="surfRecords.length < 1")
          td No personal bests for this server.

        tr(v-if="surfRecords.length > 0")
          th Type
          th Time
          th Map

        tr(v-if="surfRecords.length > 0", v-for="record of surfRecords")
          td(v-if="record.is_wr") #[span(title="This is a world record.") WR]
          td(v-else) #[span(title="This is a personal best.") PB]
          td {{ record.maptime | msTime }}
          td {{ record.map }}

      .spacer
      h3.record-list-title(@click="recordListDeathrun = !recordListDeathrun", :class="{ active: recordListDeathrun }")
        span Deathrun
        span.server-ip raid-gaming.net:28960
        chevron-down-icon
      table.record-list(v-if="recordListDeathrun", cellspacing="0", cellpadding="0")
        tr
          td Personal records are currently not being tracked for this server. We are working hard to implement this.
</template>

<script>
import ClientsService from '@/services/Clients';
import RecordsSurfService from '@/services/RecordsSurf';

import InfoSpan from '@/components/utility/InfoSpan.vue';

import EyeOutlineIcon from 'vue-material-design-icons/EyeOutline.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

export default {
  name: 'client-info',
  components: {
    InfoSpan,
    EyeOutlineIcon,
    ClockIcon,
    ChevronDownIcon,
  },
  data() {
    return {
      client: null,
      recordListDeathrun: false,
      recordListSurf: true,
      surfRecords: [],
    };
  },
  methods: {
    async load() {
      let response = await ClientsService.getClientInfo(this.$route.params.id);
      if (response.error) {
        console.log(response.error);
      } else {
        this.client = response.data;
        this.client.servers = [
          {
            name: 'Deathrun',
            rank: this.client.rank_dr ? this.client.rank_dr : 1,
            xp: this.client.rankxp_dr ? this.client.rankxp_dr : 0,
          },
          {
            name: 'Surf',
            rank: this.client.rank_surf ? this.client.rank_surf : 1,
            xp: this.client.rankxp_surf ? this.client.rankxp_surf : 0,
          },
        ];
      }

      response = await RecordsSurfService.getPersonalBests(this.$route.params.id);
      if (response.error) {
        console.log(response.error);
      } else {
        this.surfRecords = response.data;
      }
    },
  },
  created() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

.client-details {
  @media screen and (min-width: 979px) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  padding-top: 1em;

  aside.client {
    position: relative;
    width: 100%;
    background: $color-content-bg url('../assets/client-info-heading.png') center top no-repeat;
    background-size: 100%;
    border-top: 4px solid $color-accent;
    padding: 4em 2.5em;
    @media screen and (min-width: 979px) {
      width: 300px;
    }

    &.is-vip {
      padding-top: 7em;
    }

    .vip-badge {
      position: absolute;
      top: 1.5em;
      right: 1.5em;

      img {
        max-width: 60px;
      }
    }

    h2 {
      font-size: 22px;
    }

    span.user-level {
      display: inline-block;
      background: $color-accent;
      padding: 4px 6px;
      border-radius: 4px;
      font-size: 13px;
      margin-top: .5em;
    }

    .client-info {
      color: #666666;
      margin-top: 3em;

      .info-item {
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 1.5em;
        }

        .icon {
          margin-right: 1em;
          svg {
            fill: #666666;
          }
        }

        .info {
          .title {
            margin-bottom: .3em;
          }
          .value {
            color: white;
            font-size: 16px;
          }
        }
      }
    }

    .client-ranks {
      margin-top: 4em;
      > .title {
        font-size: 16px;
        margin-bottom: 1em;
      }

      .server {
        &:not(:last-child) {
          margin-bottom: 1.5em;
        }
        > .title {
          margin-bottom: 1em;
          color: rgba(white, .8);
        }

        .values {
          display: flex;
          justify-content: space-between;

          .item {
            width: 50%;

            .title {
              color: #666666;
              margin-bottom: .5em;
            }

            .value {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  .main {
    @media screen and (min-width: 979px) {
      flex: 1;
      margin-left: 3em;
    }

    @media screen and (max-width: 979px) {
      margin-top: 2em;
    }

    h2 {
      margin-bottom: 1em;
    }
  }

  h3.record-list-title {
    position: relative;
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    transition: .3s ease padding-right;

    &:hover {
      padding-right: 3.8em;
    }

    span.server-ip {
      color: #666666;
      font-size: 13px;
      text-transform: lowercase;
      font-weight: 100;
    }

    span.chevron-down-icon {
      position: absolute;
      top: 50%;
      right: 16px;
      fill: $color-fg;
      opacity: 0;
      transition: .3s ease;
      transform: translateY(-50%) rotate(90deg);
    }

    &.active span.chevron-down-icon {
      transform: translateY(-50%) rotate(0deg);
    }

    &:hover span.chevron-down-icon, &:focus span.chevron-down-icon {
      opacity: 1;
      transform: translateY(-50%) rotate(0deg);
    }
  }
}
</style>
